/* Delightful Cookie Co. — theme behaviours
   Wishlist (unified), accordions, inspiration filtering, custom inquiry steps,
   slideshow, cart/product interactions. No fake data, no fake integrations. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     MOBILE NAV
  --------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-mobile-menu-toggle]');
    if (!toggle) { return; }
    var panel = document.getElementById('MobileNavPanel');
    if (!panel) { return; }
    var open = panel.classList.toggle('open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------------------------------------------------------------
     WISHLIST — one shared implementation for every heart on the site
  --------------------------------------------------------------- */
  var WISHLIST_KEY = 'delightful-wishlist';

  function wishlistRead() {
    try {
      var raw = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      // Product wishlist only: drop any legacy non-product entries (e.g. inspiration block IDs).
      return Array.isArray(raw) ? raw.filter(function (h) { return typeof h === 'string' && h && h.indexOf('insp-') !== 0; }) : [];
    } catch (e) { return []; }
  }

  function wishlistWrite(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: list } }));
  }

  function wishlistHas(handle) { return wishlistRead().indexOf(handle) > -1; }

  function wishlistToggle(handle) {
    var list = wishlistRead();
    var index = list.indexOf(handle);
    if (index > -1) { list.splice(index, 1); } else { list.push(handle); }
    wishlistWrite(list);
    return list.indexOf(handle) > -1;
  }

  function paintHearts() {
    var list = wishlistRead();
    document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist');
      var on = list.indexOf(handle) > -1;
      var title = btn.getAttribute('data-wishlist-title') || 'this product';
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + title + (on ? ' from wishlist' : ' to wishlist'));
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length ? String(list.length) : '';
      el.classList.toggle('is-active', list.length > 0);
    });
    document.querySelectorAll('[data-wishlist-icon]').forEach(function (el) {
      el.classList.toggle('has-items', list.length > 0);
    });
  }

  document.addEventListener('click', function (event) {
    var heart = event.target.closest('[data-wishlist]');
    if (!heart) { return; }
    event.preventDefault();
    wishlistToggle(heart.getAttribute('data-wishlist'));
    paintHearts();
  });

  document.addEventListener('wishlist:change', function () { renderWishlistPage(); });
  window.addEventListener('storage', function (e) {
    if (e.key === WISHLIST_KEY) { paintHearts(); renderWishlistPage(); }
  });

  /* ---------------------------------------------------------------
     WISHLIST PAGE — real Shopify product data via the product JSON API
  --------------------------------------------------------------- */
  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (format && format.indexOf('{{') > -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/, value)
                   .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                   .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
    }
    return '$' + value;
  }

  function renderWishlistPage() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) { return; }
    var grid = root.querySelector('[data-wishlist-grid]');
    var empty = root.querySelector('[data-wishlist-empty]');
    var format = root.getAttribute('data-money-format') || '';
    var handles = wishlistRead();

    if (!handles.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      if (empty) { empty.hidden = false; }
      return;
    }
    if (empty) { empty.hidden = true; }
    grid.hidden = false;

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = '';
      var stale = [];
      products.forEach(function (p, i) {
        if (!p) { stale.push(handles[i]); return; }
        var img = p.featured_image ? p.featured_image : (p.images && p.images[0]);
        var priceLabel = money(p.price, format);
        if (p.price_varies) { priceLabel = 'From ' + money(p.price_min, format); }
        /* Same card design language as the storefront cutter card. */
        html += '<article class="cutter-card is-compact">' +
          '<a class="cutter-card-media" href="' + p.url + '">' +
          (img ? '<img src="' + img + '&width=700" alt="' + escapeHtml(p.title) + '" loading="lazy" width="700" height="700">' : '<span class="product-image-empty"></span>') +
          '</a>' +
          '<div class="cutter-card-foot">' +
          '<a href="' + p.url + '">' +
          '<h3 class="cutter-card-title">' + escapeHtml(p.title) + '</h3>' +
          '<p class="cutter-card-price">' + priceLabel + '</p>' +
          '</a>' +
          '<button type="button" class="wishlist-heart is-saved" data-wishlist="' + escapeHtml(p.handle) + '" data-wishlist-title="' + escapeHtml(p.title) + '" aria-pressed="true" aria-label="Remove ' + escapeHtml(p.title) + ' from wishlist">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/></svg>' +
          '</button>' +
          '</div></article>';
      });
      if (stale.length) {
        wishlistWrite(wishlistRead().filter(function (h) { return stale.indexOf(h) === -1; }));
      }
      grid.innerHTML = html;
      paintHearts();
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------------------------------------------------------------
     PRODUCT GALLERY / QUANTITY / ACCORDIONS
  --------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-pdp-thumb]');
    if (thumb) {
      var main = document.querySelector('[data-pdp-main]');
      if (main) { main.src = thumb.getAttribute('data-pdp-thumb'); }
      document.querySelectorAll('[data-pdp-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }

    var pill = event.target.closest('[data-option-value]');
    if (pill) {
      var group = pill.parentElement;
      group.querySelectorAll('[data-option-value]').forEach(function (b) { b.classList.remove('is-selected'); });
      pill.classList.add('is-selected');
      syncVariant();
      return;
    }

    var qty = event.target.closest('[data-qty]');
    if (qty) {
      var field = document.querySelector('[data-qty-input]');
      var display = document.querySelector('[data-qty-display]');
      var next = Math.max(1, parseInt(field.value, 10) + parseInt(qty.getAttribute('data-qty'), 10));
      field.value = next;
      display.textContent = next;
      return;
    }

    /* Accordions — only one open at a time inside each group */
    var acc = event.target.closest('[data-accordion]');
    if (acc) {
      var wasOpen = acc.getAttribute('aria-expanded') === 'true';
      var scope = acc.closest('[data-accordion-group]') || document;
      scope.querySelectorAll('[data-accordion]').forEach(function (other) {
        other.setAttribute('aria-expanded', 'false');
        var icon = other.querySelector('i');
        if (icon) { icon.textContent = '+'; }
        if (other.nextElementSibling) { other.nextElementSibling.hidden = true; }
      });
      if (!wasOpen) {
        acc.setAttribute('aria-expanded', 'true');
        var openIcon = acc.querySelector('i');
        if (openIcon) { openIcon.textContent = '\u2212'; }
        if (acc.nextElementSibling) { acc.nextElementSibling.hidden = false; }
      }
    }
  });

  /* Product recommendations (real Shopify recommendations API) */
  function loadRecommendations() {
    var rec = document.querySelector('[data-recommendations]');
    if (!rec || rec.children.length) { return; }
    fetch(rec.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var grid = parsed.querySelector('[data-recommendations]');
        if (grid && grid.innerHTML.trim()) {
          rec.innerHTML = grid.innerHTML;
          paintHearts();
        } else {
          var wrap = rec.closest('.also-love');
          if (wrap) { wrap.hidden = true; }
        }
      })
      .catch(function () {
        var wrap = rec.closest('.also-love');
        if (wrap) { wrap.hidden = true; }
      });
  }

  /* ---------------------------------------------------------------
     FORMAT (3D printed vs STL) + VARIANT SYNCING
  --------------------------------------------------------------- */
  function syncVariant() {
    var root = document.querySelector('.cutter-product');
    var data = document.querySelector('[data-variant-data]');
    if (!root || !data) { return; }
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    if (!variants || !variants.length) { return; }

    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-value]'))
      .reduce(function (acc, btn) {
        var pos = parseInt(btn.getAttribute('data-option-position'), 10);
        (acc[pos] = acc[pos] || []).push(btn);
        return acc;
      }, {});
    var positions = Object.keys(groups).map(Number).sort(function (a, b) { return a - b; });

    function chosen() {
      return positions.map(function (pos) {
        var on = groups[pos].filter(function (b) { return b.classList.contains('is-selected'); })[0] || groups[pos][0];
        on.classList.add('is-selected');
        return on.getAttribute('data-option-value');
      });
    }

    var picked = chosen();
    var match = variants.filter(function (v) {
      return picked.every(function (value, index) { return v.options[index] === value; });
    })[0];

    if (!match) {
      match = variants.filter(function (v) { return v.options[0] === picked[0]; })[0] || variants[0];
      if (match) {
        positions.forEach(function (pos, index) {
          groups[pos].forEach(function (b) {
            b.classList.toggle('is-selected', b.getAttribute('data-option-value') === match.options[index]);
          });
        });
        picked = match.options;
      }
    }

    positions.forEach(function (pos, index) {
      groups[pos].forEach(function (b) {
        var value = b.getAttribute('data-option-value');
        var exists = variants.some(function (v) {
          return v.options[index] === value && picked.every(function (c, i) { return i === index || v.options[i] === c; });
        });
        var sellable = variants.some(function (v) {
          return v.options[index] === value && v.available && picked.every(function (c, i) { return i === index || v.options[i] === c; });
        });
        b.hidden = !exists;
        b.disabled = exists && !sellable;
      });
    });

    var input = root.querySelector('[data-variant-input]');
    if (input && match) { input.value = match.id; }

    var priceEl = root.querySelector('[data-pdp-price]');
    if (priceEl && match) {
      var onSale = match.compare && match.compare > match.price;
      priceEl.classList.toggle('is-sale', !!onSale);
      priceEl.innerHTML = match.price_html + (onSale ? '<s>' + match.compare_html + '</s>' : '');
    }

    var keywords = (root.getAttribute('data-digital-keywords') || 'stl,digital,download').toLowerCase().split(',');
    var formatGroup = root.querySelector('[data-format-position]');
    var formatIndex = formatGroup ? positions.indexOf(parseInt(formatGroup.getAttribute('data-format-position'), 10)) : -1;
    var formatValue = (formatIndex > -1 ? picked[formatIndex] || '' : '').toLowerCase();
    var isDigital = keywords.some(function (word) { return word.trim() && formatValue.indexOf(word.trim()) > -1; });

    var physical = root.querySelector('[data-format-physical]');
    var digital = root.querySelector('[data-format-digital]');
    var ack = root.querySelector('[data-digital-ack]');
    var ackInput = root.querySelector('[data-digital-ack-input]');
    if (physical) { physical.hidden = isDigital; }
    if (digital) { digital.hidden = !isDigital; }
    if (ack) { ack.hidden = !isDigital; }

    var add = root.querySelector('[data-add-button]');
    if (add && match) {
      add.disabled = !match.available || (isDigital && ackInput && !ackInput.checked);
      add.textContent = match.available ? 'Add to cart' : 'Sold out';
    }
  }

  document.addEventListener('change', function (event) {
    if (event.target.closest('[data-digital-ack-input]')) { syncVariant(); }
  });

  /* ---------------------------------------------------------------
     INSPIRATION LIBRARY — working chips + search
  --------------------------------------------------------------- */
  function inspirationSetup() {
    var grid = document.querySelector('[data-insp-grid]');
    if (!grid) { return; }
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-insp-card]'));
    var chips = Array.prototype.slice.call(document.querySelectorAll('[data-insp-filter]'));
    var search = document.querySelector('[data-insp-search]');
    var empty = document.querySelector('[data-insp-empty]');
    var activeFilter = 'all';

    function params() {
      try { return new URLSearchParams(window.location.search); } catch (e) { return null; }
    }
    var qp = params();
    var initialQuery = qp ? (qp.get('q') || qp.get('cutter') || '') : '';
    var initialFilter = qp ? (qp.get('filter') || '') : '';
    if (search && initialQuery) { search.value = initialQuery; }
    if (initialFilter) { activeFilter = initialFilter.toLowerCase(); }

    function apply() {
      var query = (search ? search.value : '').trim().toLowerCase();
      var shown = 0;
      cards.forEach(function (card) {
        var haystack = (card.getAttribute('data-insp-search') || '').toLowerCase();
        var cats = (card.getAttribute('data-insp-cats') || '').toLowerCase();
        var matchesFilter = activeFilter === 'all' || cats.split('|').indexOf(activeFilter) > -1;
        var matchesQuery = !query || haystack.indexOf(query) > -1;
        var visible = matchesFilter && matchesQuery;
        card.hidden = !visible;
        if (visible) { shown++; }
      });
      if (empty) { empty.hidden = shown > 0; }
      chips.forEach(function (chip) {
        chip.classList.toggle('is-active', (chip.getAttribute('data-insp-filter') || '').toLowerCase() === activeFilter);
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function (event) {
        event.preventDefault();
        activeFilter = (chip.getAttribute('data-insp-filter') || 'all').toLowerCase();
        apply();
      });
    });
    if (search) {
      search.addEventListener('input', apply);
      var form = search.closest('form');
      if (form) { form.addEventListener('submit', function (e) { e.preventDefault(); apply(); }); }
    }
    apply();
  }

  /* Inspiration detail gallery */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-insp-thumb]');
    if (!thumb) { return; }
    var main = document.querySelector('[data-insp-main]');
    if (main) { main.src = thumb.getAttribute('data-insp-thumb'); }
  });

  /* ---------------------------------------------------------------
     CUSTOM COOKIE INQUIRY — four steps, real Shopify contact form
  --------------------------------------------------------------- */
  function inquirySetup() {
    var form = document.querySelector('[data-inquiry-form]');
    if (!form) { return; }
    var steps = Array.prototype.slice.call(form.querySelectorAll('[data-inquiry-step]'));
    var dots = Array.prototype.slice.call(document.querySelectorAll('[data-inquiry-dot]'));
    var current = 0;

    var preselect = null;
    try { preselect = new URLSearchParams(window.location.search).get('collection'); } catch (e) {}
    if (preselect) {
      form.querySelectorAll('[name="contact[Preferred collection]"]').forEach(function (radio) {
        if (radio.value.toLowerCase().indexOf(preselect.toLowerCase()) > -1) { radio.checked = true; }
      });
    }

    function show(index) {
      current = Math.max(0, Math.min(steps.length - 1, index));
      steps.forEach(function (step, i) { step.hidden = i !== current; });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        dot.classList.toggle('is-done', i < current);
      });
      if (current === steps.length - 1) { buildReview(); }
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function validate(step) {
      var ok = true;
      step.querySelectorAll('input, select, textarea').forEach(function (field) {
        if (!field.checkValidity()) {
          field.reportValidity();
          ok = false;
          return false;
        }
      });
      return ok;
    }

    var CARD_TITLES = ['Your Event', 'Your Cookie Vision', 'Your Inspiration'];

    function buildReview() {
      var target = form.querySelector('[data-inquiry-review]');
      if (!target) { return; }
      var html = '';
      steps.forEach(function (step, index) {
        if (step.hasAttribute('data-review-step')) { return; }
        var rows = '';
        step.querySelectorAll('[name^="contact["]').forEach(function (field) {
          if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) { return; }
          var value = field.type === 'checkbox' ? 'Yes' : field.value;
          if (!value || !String(value).trim()) { return; }
          var label = field.getAttribute('data-label') || field.getAttribute('name').replace('contact[', '').replace(']', '');
          rows += '<div class="review-row"><dt>' + escapeHtml(label) + '</dt><dd>' + escapeHtml(value).replace(/\n/g, '<br>') + '</dd></div>';
        });
        if (!rows) { return; }
        html += '<section class="review-card">' +
          '<header class="review-card-head">' +
          '<h3>' + escapeHtml(CARD_TITLES[index] || 'Details') + ' <i aria-hidden="true">\u2661</i></h3>' +
          '<button type="button" class="review-edit" data-inquiry-goto="' + index + '">Edit &rarr;</button>' +
          '</header><dl class="review-list">' + rows + '</dl></section>';
      });
      target.innerHTML = html || '<p class="inquiry-review-empty">Complete the earlier steps to see your summary.</p>';
    }

    form.addEventListener('click', function (event) {
      var next = event.target.closest('[data-inquiry-next]');
      if (next) {
        event.preventDefault();
        if (validate(steps[current])) { show(current + 1); }
        return;
      }
      var goTo = event.target.closest('[data-inquiry-goto]');
      if (goTo) {
        event.preventDefault();
        show(parseInt(goTo.getAttribute('data-inquiry-goto'), 10));
        return;
      }
      var back = event.target.closest('[data-inquiry-back]');
      if (back) { event.preventDefault(); show(current - 1); }
    });

    /* "How did you hear about us" — reveal the write-in field only for Other */
    var hearSelect = form.querySelector('[data-hear-select]');
    var hearOther = form.querySelector('[data-hear-other]');
    if (hearSelect && hearOther) {
      var syncHear = function () {
        var isOther = hearSelect.value.toLowerCase() === 'other';
        hearOther.hidden = !isOther;
        var input = hearOther.querySelector('input');
        if (input && !isOther) { input.value = ''; }
      };
      hearSelect.addEventListener('change', syncHear);
      syncHear();
    }

    /* Quantity is a full-dozen select, so the 24 minimum can never be beaten.
       The legacy minimum note stays hidden. */
    var qtyNote = form.querySelector('[data-inquiry-minimum]');
    if (qtyNote) { qtyNote.hidden = true; }


    show(0);
  }

  /* ---------------------------------------------------------------
     CONTACT PAGE — reveal the write-in topic when "Other" is selected
  --------------------------------------------------------------- */
  function contactSetup() {
    var topic = document.querySelector('[data-contact-topic]');
    var other = document.querySelector('[data-contact-topic-other]');
    if (!topic || !other) { return; }
    function toggle() {
      var isOther = topic.value.toLowerCase() === 'other';
      other.hidden = !isOther;
      var input = other.querySelector('input');
      if (input) { input.required = isOther; }
    }
    topic.addEventListener('change', toggle);
    toggle();
  }

  /* ---------------------------------------------------------------
     PRODUCT CAROUSEL (New & Delightful) — native scroll + arrows
  --------------------------------------------------------------- */
  function carouselSetup() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      if (root.dataset.carouselReady === 'true') { return; }
      root.dataset.carouselReady = 'true';
      var track = root.querySelector('[data-carousel-track]');
      if (!track) { return; }
      var section = root.closest('section') || root;
      var prev = section.querySelector('[data-carousel-prev]');
      var next = section.querySelector('[data-carousel-next]');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function step() {
        var item = track.querySelector('.carousel-item');
        return item ? item.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
      }
      function scrollBy(dir) {
        track.scrollBy({ left: dir * step(), behavior: reduced ? 'auto' : 'smooth' });
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) { prev.disabled = track.scrollLeft <= 2; }
        if (next) { next.disabled = track.scrollLeft >= max; }
        var overflowing = track.scrollWidth > track.clientWidth + 4;
        var arrows = section.querySelector('.carousel-arrows');
        if (arrows) { arrows.hidden = !overflowing; }
      }
      if (prev) { prev.addEventListener('click', function () { scrollBy(-1); }); }
      if (next) { next.addEventListener('click', function () { scrollBy(1); }); }
      track.addEventListener('scroll', sync, { passive: true });
      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); scrollBy(1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); scrollBy(-1); }
      });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------------------------------------------------------------
     SLIDESHOW
  --------------------------------------------------------------- */
  function slideshowSetup() {
    document.querySelectorAll('[data-slideshow]').forEach(function (root) {
      var track = root.querySelector('[data-slideshow-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      if (!track || slides.length < 1) { return; }
      var dotsWrap = root.querySelector('[data-slideshow-dots]');
      var index = 0;
      var timer = null;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var interval = Math.max(3000, parseInt(root.getAttribute('data-interval'), 10) * 1000 || 6000);
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (dotsWrap) {
        dotsWrap.innerHTML = slides.map(function (_, i) {
          return '<button type="button" role="tab" aria-label="Go to slide ' + (i + 1) + '" data-slideshow-dot="' + i + '"></button>';
        }).join('');
      }

      function go(next) {
        index = (next + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        slides.forEach(function (s, i) {
          s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
          s.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = i === index ? 0 : -1; });
        });
        if (dotsWrap) {
          dotsWrap.querySelectorAll('[data-slideshow-dot]').forEach(function (d, i) {
            d.classList.toggle('is-active', i === index);
            d.setAttribute('aria-selected', i === index ? 'true' : 'false');
          });
        }
      }

      function start() {
        if (!autoplay || reduced || slides.length < 2) { return; }
        stop();
        timer = window.setInterval(function () { go(index + 1); }, interval);
      }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

      root.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-slideshow-dot]');
        if (dot) { go(parseInt(dot.getAttribute('data-slideshow-dot'), 10)); stop(); start(); return; }
        if (event.target.closest('[data-slideshow-prev]')) { go(index - 1); stop(); start(); return; }
        if (event.target.closest('[data-slideshow-next]')) { go(index + 1); stop(); start(); return; }
        var toggle = event.target.closest('[data-slideshow-pause]');
        if (toggle) {
          autoplay = !autoplay;
          toggle.setAttribute('aria-pressed', autoplay ? 'false' : 'true');
          toggle.textContent = autoplay ? 'Pause' : 'Play';
          if (autoplay) { start(); } else { stop(); }
        }
      });
      root.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { go(index + 1); }
        if (event.key === 'ArrowLeft') { go(index - 1); }
      });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);

      go(0);
      start();
    });
  }

  /* ---------------------------------------------------------------
     COOKIE GALLERY — category filtering
  --------------------------------------------------------------- */
  function gallerySetup() {
    document.querySelectorAll('[data-gallery-grid]').forEach(function (grid) {
      var section = grid.closest('section');
      if (!section) { return; }
      var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-filter]'));
      if (!buttons.length) { return; }
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var key = button.getAttribute('data-gallery-filter');
          buttons.forEach(function (other) { other.classList.toggle('is-active', other === button); });
          grid.querySelectorAll('[data-gallery-category]').forEach(function (item) {
            var cat = (item.getAttribute('data-gallery-category') || '').toLowerCase();
            item.hidden = !(key === 'all' || cat === key);
          });
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     REVIEWS — mobile tabs between the two columns
  --------------------------------------------------------------- */
  function reviewsSetup() {
    document.querySelectorAll('[data-reviews-columns]').forEach(function (root) {
      var section = root.closest('section');
      var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-reviews-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-reviews-panel]'));
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-reviews-tab');
          tabs.forEach(function (other) {
            var on = other === tab;
            other.classList.toggle('is-active', on);
            other.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (panel) {
            panel.classList.toggle('is-active', panel.getAttribute('data-reviews-panel') === key);
          });
        });
      });
    });

    /* Review form — show only the fields that match the chosen category */
    var choices = Array.prototype.slice.call(document.querySelectorAll('[data-review-category]'));
    if (!choices.length) { return; }
    var customFields = Array.prototype.slice.call(document.querySelectorAll('[data-review-custom-only]'));
    var toolFields = Array.prototype.slice.call(document.querySelectorAll('[data-review-tools-only]'));
    function syncCategory() {
      var selected = choices.filter(function (choice) { return choice.checked; })[0];
      var value = selected ? selected.value.toLowerCase() : '';
      var isTools = value.indexOf('cutter') > -1 || value.indexOf('tool') > -1;
      customFields.forEach(function (field) { field.hidden = !selected || isTools; });
      toolFields.forEach(function (field) { field.hidden = !selected || !isTools; });
    }
    choices.forEach(function (choice) { choice.addEventListener('change', syncCategory); });
    syncCategory();
  }

  /* ---------------------------------------------------------------
     NAVIGATION — expandable groups on mobile
  --------------------------------------------------------------- */
  function navSetup() {
    document.querySelectorAll('[data-nav-group-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        var panel = toggle.nextElementSibling;
        if (panel) { panel.hidden = open; }
      });
    });
  }

  /* ---------------------------------------------------------------
     BOOT
  --------------------------------------------------------------- */
  function boot() {
    paintHearts();
    renderWishlistPage();
    syncVariant();
    loadRecommendations();
    inspirationSetup();
    inquirySetup();
    contactSetup();
    carouselSetup();
    slideshowSetup();
    gallerySetup();
    reviewsSetup();
    navSetup();
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
